import { render, staticRenderFns } from "./DistributionDetailList.vue?vue&type=template&id=63413220"
import script from "./DistributionDetailList.js?vue&type=script&lang=js&external"
export * from "./DistributionDetailList.js?vue&type=script&lang=js&external"
import style0 from "./DistributionDetailList.vue?vue&type=style&index=0&id=63413220&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports